import React from "react";

import { useRegistration } from "./useRegistration";
import { CompanyProfile } from "./CompanyProfile";
import { Addresses } from "./Addresses";
import { Contacts } from "./Contacts";
import { Quotas } from "./Quotas";
import { PartNumbers } from "./PartNumbers";
import { TAccountOnly } from "./TAccountOnly";

export const RegisterCompanyDetails = () => {
  const { coforMode, coforOptions } = useRegistration((state) => ({
    coforOptions: state.coforOptions,
    coforMode: state.coforMode,
  }));

  if (!coforMode && !coforOptions.length > 0) {
    return null;
  }

  return (
    <div className="captchaComplete">
      <CompanyProfile />
      <Addresses />
      <Contacts />
      <Quotas />
      <TAccountOnly>
        <PartNumbers />
      </TAccountOnly>
    </div>
  );
};
